import { Spacer } from "shared/layout";
import { space } from "shared/styles/constants";
import styled from "styled-components";

export const StyledEventPeopleBlock = styled(Spacer)`
  @media print {
    margin-top: 0 !important;
    padding: ${space.s};
    display: block;
    page-break-inside: avoid;
  }
`;
